
import Scroll from '@/components/pull-refresh';
import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch} from '@/api/dataHandling';
import {chinamobile} from '@/api/validate';
import {getken} from '@/api/getToken';
import XTable from 'vux/src/components/x-table/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data () {
return {
top:'',
scrollBottom:'45px',
recordsData:[],
recordsDialog:false,
chinamobile,
name:'',
phone:'',
loadmoreShow:true,
loadmoreTxt:'加载中····',
bottomCount: 20,
seachplaceholder:'请输入姓名',
beforeSubmitDisable:false,
registerbeforeDialog:false,
basemessage:{
certType:'01',
certNo:'',
},
newsDiv:'',
msg:'',
newDialog:false,
editDialog:false,
newsindex:'',
laoadingNum:1,
newsOption:[],
SFZiconType:'',
toastshow:false,
toastTxt:'',
searchVal:'',
tabindex:0,
tabOption:['助孕登记'],
resultOption:[],
certTypeoptions: [],
}
},
directives: {
TransferDom
},
components: {
Scroll,XTable,Confirm,Flexbox, FlexboxItem,Scroller,CheckIcon,Search, LoadMore,Toast,Tab, TabItem,XDialog,Qrcode,XInput,PopupRadio,Cell,XTextarea, Group, XHeader,XButton
},
methods:{
onInfinite(done) {
this.laoadingNum++;
this.seachSumbit(true);
done();
},  //上拉
editbasemsg(item){
this.editDialog = true;
this.name = item.name;
this.phone = item.phone;
this.sureParmas = {
userId:this.personInfoid,
registerType:item.registerType,
id:item.id,
certNo:item.certNo,
channelId:item.channelId,
channelInfoId:item.channelInfoId,
};
},   //修改基本信息
surebaseMsg(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
let _this = this;
this.sureParmas.name = this.name.trim();
this.sureParmas.phone = this.phone.trim();
if(this.phone.trim() && this.name.trim() && chinamobile(this.phone).valid){
fetch('post',urlConfig.pregnancyRegistratSubmit,this.sureParmas).then(response => {
this.editDialog = false;
promptMessage('提示', '修改成功！',function(){
_this.seachSumbit();

});
this.$store.commit('updateLoadingStatus',{isLoading:false});

}).catch(error => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示',error);

});
}else if (this.name.trim() ==''){
this.toastshow = true;
this.toastTxt = '姓名不能为空';
}else if (this.phone.trim() ==''){
this.toastshow = true;
this.toastTxt = '电话号码不能为空';
}else{
this.toastshow = true;
this.toastTxt = chinamobile(this.phone).msg;
}

}, //确认修改基本信息
Sfzvalidate(){
this.basemessage.certNo = this.basemessage.certNo.trim();
if(this.basemessage.certType == '01'){
if(this.basemessage.certNo){
if(this.IdCodeValid(this.basemessage.certNo)){
this.SFZiconType = '';
}else{
this.SFZiconType = 'error';
}
}
}else{
this.SFZiconType = '';
}
}, //身份证验证
IdCodeValid(code){
let _this = this;
var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
var row = true;
if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X])$/.test(code)){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误";
}else if(!city[code.substr(0,2)]){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误,地址编码错误";
}else{

if(code.length == 18){
code = code.split('');


var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];

var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
var sum = 0;
var ai = 0;
var wi = 0;
for (var i = 0; i < 17; i++)
{
ai = code[i];
wi = factor[i];
sum += ai * wi;
}
if(parity[sum % 11] != code[17].toUpperCase()){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误,校验位错误";
}
}
}
return row;
},
btydjClick(num){
if(num){
window.localStorage.setItem('pregistrationTxt',null);
this.$router.push({path:'/pregnancyRegistration',query:{sfzh:num,btdj:17}});
}else {
promptMessage('提示','该推荐人的身份证信息未录入系统，请联系信息科！')
}


},  //帮他预登记跳转
searchBlur(){
if(this.searchVal.trim() ==''){
this.serchCommonMethod();
}
},
serchCommonMethod(){
if(this.tabindex == 0 /*|| this.tabindex == 1 */){
this.seachSumbit();

}else{  //帮他人登记
/*let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
this.$nextTick(function(){
this.searchVal = this.searchVal.trim();
this.searchVal = this.searchVal.trim().replace(patrn, "")
if(/^1[3456789]\d{9}$/.test(this.searchVal) && this.searchVal){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyPatientsearchTel,{
"certNo": "",
"channelIdent": "",
"id": "",
"identityNo": this.searchVal,
"name": "",
"page": 0,
"personInfoId": "",
"phone": "",
"rows": 0,
"userId": ""
}).then(response => {
this.resultOption = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

});
}else{

if(!this.searchVal){
return false;
}
this.toastshow = true;
this.toastTxt = '电话号码不正确，请核实！';

}
})*/
if(this.searchVal){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyPatientsearchTel,{
"certNo": "",
"channelIdent": "",
"id": "",
"identityNo": this.searchVal,
"name": "",
"page": 0,
"personInfoId": "",
"phone": "",
"rows": 0,
"userId": ""
}).then(response => {
this.resultOption = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

});
}

}
},
registerbeforeSubmit(){
if(this.basemessage.certType.trim() !='' && this.basemessage.certNo.trim() !=''){
let SFZSex = (this.basemessage.certNo.trim()).substring(this.basemessage.certNo.length-2,this.basemessage.certNo.length-1);
if(SFZSex%2 == 0) {  //女
this.basemessage.sex = 2;
}else{  //男
this.basemessage.sex = 1;
}   //sex赋值
if(this.basemessage.certNo.trim().length==15){
this.basemessage.birthday = "19"+this.basemessage.certNo.trim().substring(6,8)+"-"+this.basemessage.certNo.trim().substring(8,10)+"-"+ this.basemessage.certNo.trim().substring(10,12);
}
if(this.basemessage.certNo.trim().length==18){
this.basemessage.birthday = this.basemessage.certNo.trim().substring(6,10)+"-"+this.basemessage.certNo.trim().substring(10,12)+"-"+ this.basemessage.certNo.trim().substring(12,14);
}  //出生日期赋值
if(this.preitem.sex ==2 || this.preitem.sex == this.basemessage.sex){
this.beforeSubmitDisable = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.basemessage.id = this.preitem.id;
this.basemessage.userid = window.localStorage.getItem('userid');
fetch('post',urlConfig.preBeforeRegisterSave,this.basemessage).then(response => {
this.registerbeforeDialog = false;
promptMessage('提示','登记成功！');
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.beforeSubmitDisable = false;
this.seachSumbit();
}).catch(error => {
this.registerbeforeDialog = false;
})


}else{
promptMessage('提示','输入的身份证信息人的性别与系统中登记的性别不一致，请核实！')
}
}else {
promptMessage('提示','证件号和证件类型不能为空！')
}

},
registerbeforebtn(item){
this.preitem = item;
let certTypeoptions = JSON.parse(window.localStorage.getItem('certTypeoptions'));
if(certTypeoptions){
this.certTypeoptions = certTypeoptions;
}else{

this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyRegistratGetType).then(response => {
this.certTypeoptions = response.certType;  
for(let i=0;i<response.certType.length;i++){
this.certTypeoptions[i]['key'] = response.certType[i].certCode;
this.certTypeoptions[i]['value'] = response.certType[i].certName;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
})
}
for(let j in this.basemessage){
this.basemessage[j] = '';
}
this.registerbeforeDialog = true;
}, //打开转预登记弹窗
jsGetAge(strBirthday){
var returnAge;
var strBirthdayArr=strBirthday.split("-");
var birthYear = strBirthdayArr[0];
var birthMonth = strBirthdayArr[1];
var birthDay = strBirthdayArr[2];

var d = new Date();
var nowYear = d.getFullYear();
var nowMonth = d.getMonth() + 1;
var nowDay = d.getDate();
if(nowYear == birthYear){
returnAge = 0;
} else{
var ageDiff = nowYear - birthYear ; 
if(ageDiff > 0){
if(nowMonth == birthMonth) {
var dayDiff = nowDay - birthDay;
if(dayDiff < 0)
{
returnAge = ageDiff - 1;
}
else
{
returnAge = ageDiff ;
}
}
else
{
var monthDiff = nowMonth - birthMonth;
if(monthDiff < 0)
{
returnAge = ageDiff - 1;
}
else
{
returnAge = ageDiff ;
}
}
}
else
{
returnAge = -1;
}
}

return returnAge;

},
tabItemClick(index){
this.tabIndex = index;
this.laoadingNum = 1;
this.searchVal = '';
if(index == 0 /*|| index == 1 */){
this.seachSumbit();
this.seachplaceholder = '请输入姓名';
this.$refs.scroll.$refs.yoScroll.scrollTop = 0;

}else{
this.resultOption = [];
this.onFetching = true;
this.seachplaceholder = '请输入电话或姓名';
this.loadmoreTxt = '暂无数据';
this.loadmoreShow = false;
}
if(index == 0){
this.scrollBottom = '45px';
}else{
this.scrollBottom = '0px';
}

}, //切换
seachSumbit(obj){
this.loadmoreTxt = '加载中...';
this.$store.commit('updateLoadingStatus',{isLoading:true});
let pamras = {
channelContact: "",
page: 0,
patientChannelId: "",
preRegisterBeginDate: "",
preRegisterEndDate: "",
rows: 15 * this.laoadingNum,
userId: window.localStorage.getItem('userid')
}
pamras.patientInfo = this.searchVal.trim();
let searchUrl = '';
if(this.tabindex == 0){
searchUrl = urlConfig.pregnancyPatientDetailsgetYQ;
}/*else {
searchUrl = urlConfig.pregnancyPatientDetailsgetZY;
}*/
fetch('post',searchUrl,pamras).then(response => {

this.resultOption = response.result;
if(this.resultOption.length == 0){
this.loadmoreShow = false;
this.loadmoreTxt = '暂无数据';
this.onFetching = true;
}else if(this.resultOption.length <response.size){
this.loadmoreShow = false;
this.loadmoreTxt = '已经到底了';
}else{
this.loadmoreShow = false;
this.loadmoreTxt = '上拉加载更多';
this.onFetching = false;
}
for(let i=0;i<this.resultOption.length;i++){
if(this.resultOption[i].sex == 2){
this.resultOption[i].sexTxt = '女';
}else if(this.resultOption[i].sex == 1){
this.resultOption[i].sexTxt = '男';
}else {
this.resultOption[i].sexTxt = '未知';
}
this.resultOption[i].registerDateTxt = this.resultOption[i].registerDate.substring(0,10);
if(this.resultOption[i].birthday.trim() !==''){
this.resultOption[i].age = this.jsGetAge(this.resultOption[i].birthday);
}else{
this.resultOption[i].age ='';
}
}
if(obj){

this.onFetching = false;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
this.getNewsData();
},//搜索
getNewsData(){
fetch('post',urlConfig.pregnancyPatientgetNews,{
"id": "",
"personInfoId": this.personInfoid,
"templetContent": "",
"templetName": ""
}).then(response => {
this.newsOption = response;
for(let i=0;i<response.length;i++){
this.newsOption[i].value = response[i].templetName;
this.newsOption[i].key = response[i].id;
}
}).catch(error => {

})
},//获取数据
newChange(index){
for(let i=0;i<this.newsOption.length;i++){
if(index == this.newsOption[i].key){
this.msg = this.newsOption[i].templetContent;

}
}
},
dialogsNewshide(){

this.msg = '';
this.newsindex = '';

},
sendNews(){
this.msg = this.msg.trim();
if(this.msg){
this.$store.commit('updateLoadingStatus',{isLoading:true});
let sendParma = [];
for(let i =0;i<this.resultOption.length;i++){
if(this.resultOption[i].checkdemo){
sendParma.push({
name: this.resultOption[i].name,
phone: this.resultOption[i].phone,
preBeforeId: this.resultOption[i].id
})
}
}
for(let i = 0;i<sendParma.length;i++){
sendParma[i].msg = this.msg;
}
fetch('post',urlConfig.pregnancyPatientNewssend,sendParma).then(response => {
promptMessage('提示','短信发送成功!');
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.newDialog = false;
}).catch(error => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示',error);
})
}else{
this.toastTxt = '短信内容不能为空';
this.toastshow = true;
}

},//发送短信
sendDialogBtn(){
let checkedIndex = 0;
for(let i =0;i<this.resultOption.length;i++){
if(this.resultOption[i].checkdemo){
checkedIndex++;
}
}
if(checkedIndex == 0){
promptMessage('提示','请勾选需要发送短信的患者信息!')
}else{
this.newDialog = true;
}
}, // 打开发送短信窗口
MedicalrecordsClick(certNo){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.recordsData = [];

fetch('get',urlConfig.pregnancyPatientMedicalrecords + certNo).then(response => {
this.recordsData = response;
this.recordsDialog = true;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示',error);
})
},  // 查看患者就诊记录
},

mounted(){
getken(this.seachSumbit);
this.personInfoid =  window.localStorage.getItem('userid');
this.newsDiv =  window.localStorage.getItem('empNo');
this.userStatus = window.localStorage.getItem('userStatus');
if(this.newsDiv == 1 && this.userStatus == 1){
this.tabOption.push('帮他人登记')
};
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
});
$('input').on('blur', function () {
setTimeout(function(){
var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
window.scrollTo(0, Math.max(scrollHeight - 1, 0));
}, 100);
});
})
}
}



// WEBPACK FOOTER //
// ./src/project/pregnancyProject/pregnancyPatientDetails.vue